export default __webpack_public_path__ + "static/notary-banner-mobile-0c78dd36e0ef16d4e2649b64ca96ff5d.png";